<template>
  <div class="slider">
    <div class="slider__nav">
      <nav-popup v-if="isMobile" :itemList="navList" :active="active" @select="onSelect" />
      <slider-nav v-else :itemList="navList" :active="active" @select="onSelect" />
    </div>

    <slider-content :item="content">
      <double-btn v-if="disabledNext" iconName="redo" iconNameHover="redo-hover" @click="onAgain">Читать с начала</double-btn>

      <button v-else type="button" class="btn btn-secondary" @click="onNext">
        Читать дальше
        <icon class="btn-secondary__icon" name="arrowNext" width="24" height="14" />
      </button>
    </slider-content>
  </div>
</template>

<script>
import NavPopup from '../shared/NavPopup'
import DoubleBtn from '../shared/DoubleBtn'
import Icon from '../shared/Icon'
import SliderNav from './SliderNav'
import SliderContent from './SliderContent'

export default {
  components: {
    NavPopup,
    DoubleBtn,
    Icon,
    SliderNav,
    SliderContent
  },
  data () {
    return {
      contribution: [],
      active: 0,
      isBtnHover: false
    }
  },
  computed: {
    navList () {
      return this.contribution.map(item => item.name)
    },
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.lg)
    },
    content () {
      return this.contribution[this.active]
    },
    disabledNext () {
      return this.active === (this.navList.length - 1)
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    scrollTo () {
      const top = document.getElementById('slider').offsetTop
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    fetchData () {
      this.$http.static.get('/data/contribution.json')
        .then((response) => {
          this.contribution = response.data
        }, (error) => {
          console.error(error)
        }).catch(() => null)
    },
    onSelect (index) {
      this.active = index
    },
    onNext () {
      this.active++
      this.scrollTo()
    },
    onAgain () {
      this.active = 0
      this.scrollTo()
    }
  }
}
</script>

<style lang="scss" scoped>
.slider {
  &__nav {
    margin-bottom: 50px;

    @include media-breakpoint-up(md) {
      margin-bottom: 60px;
    }
  }
}
</style>
